import { createResource } from 'react-resource-router';

import { type SavedSearches } from '../../../common/types';
import { getSavedSearchesEndpoint } from '../endpoints';

export const savedSearchesResource = createResource<SavedSearches>({
	type: 'savedSearchesResource',
	getKey: () => 'savedSearchesResource',
	getData: () => getSavedSearchesEndpoint(),
	maxAge: 5 * 60 * 1000, // 5 minutes
	isBrowserOnly: true,
});
